import React from 'react';
import AdminLogin from '../admin/AdminLogin';

const AdminLoginPage = () => {
  return <AdminLogin />;
};

export default AdminLoginPage;

